import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import SeoUsageLandingPage from '../components/SeoUsageLandingPage';
import { SEO_LANDINGS } from '../data/seoLandings';

/**
 * Page unique qui résout n'importe quelle landing SEO depuis l'URL.
 * Toute la config est dans /app/frontend/src/data/seoLandings.js
 */
const SeoLandingPage = () => {
  const location = useLocation();
  const slug = location.pathname.replace(/^\//, '');
  const config = SEO_LANDINGS[slug];

  if (!config) {
    return <Navigate to="/" replace />;
  }

  // Force remount on slug change so internal state (loading, filters) is reset.
  return <SeoUsageLandingPage key={slug} {...config} />;
};

export default SeoLandingPage;
